import { saveAs } from "file-saver";

import { transferFileToNative, isInsideGoReactNativeApp } from "./ReactNativeAppHelpers";

export function saveFile(blob, filename) {
    isInsideGoReactNativeApp() ? transferFileToNative(blob, filename) : saveAs(blob, filename);
}
